import { useState, useEffect } from "react";
import Api from '../api/Api';

const COLORS = {
  primary: "#FF6B00",
  primaryDark: "#E55A00",
  text: "#111827",
  muted: "#6B7280",
  border: "#E5E7EB",
  bg: "#F4F6FA",
  error: "#EF4444",
};

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeSlideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes float { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-14px); } }
      @keyframes pulse { 0%,100% { opacity: 0.6; } 50% { opacity: 1; } }
      @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { background: #0f0c29; }
      ::-webkit-scrollbar { width: 4px; }
      ::-webkit-scrollbar-thumb { background: #FF6B00; border-radius: 10px; }
      input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #1a1740 inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    `;
    document.head.appendChild(style);
    setTimeout(() => setMounted(true), 80);
  }, []);

  const validate = () => {
    const e = {};
    if (!form.email.trim()) e.email = "Email obrigatório";
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = "Email inválido";
    if (!form.password) e.password = "Senha obrigatória";
    else if (form.password.length < 4) e.password = "Senha muito curta";
    return e;
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: null }));
    setServerError("");
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    setServerError("");
    try {
    
      const result = await Api.Login({email:  form.email,password: form.password});
      if (result?.success && result?.user?.token) {
        localStorage.setItem("user", JSON.stringify(result.user));
   
 
     
     
         window.location.href = "/produtos";
      } else {
        setServerError(result?.message || "Credenciais inválidas. Tente novamente.");
      }
    } catch (err) {
      setServerError("Erro de conexão. Verifique a sua ligação e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f0c29 0%, #302b63 55%, #24243e 100%)",
      fontFamily: "'Nunito', sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
      position: "relative",
      overflow: "hidden",
      opacity: mounted ? 1 : 0,
      transition: "opacity 0.5s ease",
    }}>

      {/* ── Background decorations ── */}
      <div style={{
        position: "absolute", top: -120, right: -120,
        width: 480, height: 480, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(255,107,0,0.12) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: -100, left: -100,
        width: 400, height: 400, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,102,255,0.1) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", top: "45%", left: "5%",
        width: 180, height: 180, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(255,214,0,0.06) 0%, transparent 70%)",
        pointerEvents: "none",
        animation: "pulse 4s ease-in-out infinite",
      }} />

      {/* ── Floating blobs ── */}
      {[
        { top: "12%", left: "8%", size: 48, delay: "0s", icon: "⚡" },
        { top: "20%", right: "10%", size: 40, delay: "0.8s", icon: "📦" },
        { bottom: "18%", left: "6%", size: 44, delay: "1.4s", icon: "🚀" },
        { bottom: "22%", right: "8%", size: 36, delay: "0.4s", icon: "🌍" },
      ].map((blob, i) => (
        <div key={i} style={{
          position: "absolute",
          top: blob.top, bottom: blob.bottom,
          left: blob.left, right: blob.right,
          width: blob.size, height: blob.size,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: blob.size * 0.45,
          animation: `float 5s ease-in-out infinite`,
          animationDelay: blob.delay,
          pointerEvents: "none",
        }}>{blob.icon}</div>
      ))}

      {/* ── Logo ── */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        marginBottom: 32,
        animation: "fadeSlideUp 0.5s ease forwards",
      }}>
        <div style={{
          width: 48, height: 48,
          background: "linear-gradient(135deg, #FF6B00, #FF3D00)",
          borderRadius: 14,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 24, fontWeight: 900, color: "#fff",
          boxShadow: "0 8px 24px rgba(255,107,0,0.45)",
        }}>S</div>
        <div>
          <div style={{ fontWeight: 900, fontSize: 22, color: "#fff", letterSpacing: -0.5, lineHeight: 1.1 }}>SATEC</div>
          <div style={{ fontSize: 9, color: COLORS.primary, fontWeight: 700, letterSpacing: 3 }}>IMPORTS</div>
        </div>
      </div>

      {/* ── Card ── */}
      <div style={{
        background: "rgba(255,255,255,0.04)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 28,
        padding: "36px 32px 40px",
        width: "100%",
        maxWidth: 420,
        boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
        animation: "fadeSlideUp 0.55s ease 0.1s both",
      }}>
        {/* Card header */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            display: "inline-block",
            background: "rgba(255,107,0,0.15)",
            border: "1px solid rgba(255,107,0,0.3)",
            color: COLORS.primary, fontSize: 10, fontWeight: 800,
            padding: "5px 16px", borderRadius: 20,
            letterSpacing: 2, marginBottom: 14,
          }}>🔐 ÁREA RESTRITA</div>
          <h1 style={{
            fontSize: 26, fontWeight: 900, color: "#fff",
            letterSpacing: -0.5, lineHeight: 1.2, marginBottom: 8,
          }}>Bem-vindo de volta</h1>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", fontWeight: 600, lineHeight: 1.6 }}>
            Aceda ao painel de gestão da SATEC
          </p>
        </div>

        {/* Server error */}
        {serverError && (
          <div style={{
            background: "rgba(239,68,68,0.12)",
            border: "1px solid rgba(239,68,68,0.3)",
            borderRadius: 12, padding: "12px 16px",
            marginBottom: 20,
            display: "flex", alignItems: "center", gap: 10,
          }}>
            <span style={{ fontSize: 16 }}>⚠️</span>
            <span style={{ fontSize: 13, color: "#FCA5A5", fontWeight: 700 }}>{serverError}</span>
          </div>
        )}

        {/* Form */}
        <div>
          {/* Email */}
          <div style={{ marginBottom: 18 }}>
            <label style={{
              display: "block", fontSize: 12, fontWeight: 800,
              color: "rgba(255,255,255,0.7)", marginBottom: 8, letterSpacing: 0.3,
            }}>Email</label>
            <div style={{ position: "relative" }}>
              <span style={{
                position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
                fontSize: 16, pointerEvents: "none",
              }}>✉️</span>
              <input
                type="email"
                placeholder="seu@email.com"
                value={form.email}
                onChange={e => handleChange("email", e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                style={{
                  width: "100%",
                  padding: "14px 16px 14px 44px",
                  borderRadius: 12,
                  border: `2px solid ${errors.email ? "rgba(239,68,68,0.6)" : "rgba(255,255,255,0.1)"}`,
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  fontSize: 14,
                  fontFamily: "'Nunito', sans-serif",
                  fontWeight: 600,
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.2s, background 0.2s",
                }}
                onFocus={e => {
                  e.target.style.borderColor = "rgba(255,107,0,0.7)";
                  e.target.style.background = "rgba(255,255,255,0.09)";
                }}
                onBlur={e => {
                  e.target.style.borderColor = errors.email ? "rgba(239,68,68,0.6)" : "rgba(255,255,255,0.1)";
                  e.target.style.background = "rgba(255,255,255,0.06)";
                }}
              />
            </div>
            {errors.email && (
              <div style={{ fontSize: 11, color: "#FCA5A5", marginTop: 6, fontWeight: 700, paddingLeft: 4 }}>
                ⚠ {errors.email}
              </div>
            )}
          </div>

          {/* Password */}
          <div style={{ marginBottom: 24 }}>
            <label style={{
              display: "block", fontSize: 12, fontWeight: 800,
              color: "rgba(255,255,255,0.7)", marginBottom: 8, letterSpacing: 0.3,
            }}>Senha</label>
            <div style={{ position: "relative" }}>
              <span style={{
                position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
                fontSize: 16, pointerEvents: "none",
              }}>🔑</span>
              <input
                type={showPass ? "text" : "password"}
                placeholder="••••••••"
                value={form.password}
                onChange={e => handleChange("password", e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                style={{
                  width: "100%",
                  padding: "14px 48px 14px 44px",
                  borderRadius: 12,
                  border: `2px solid ${errors.password ? "rgba(239,68,68,0.6)" : "rgba(255,255,255,0.1)"}`,
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  fontSize: 14,
                  fontFamily: "'Nunito', sans-serif",
                  fontWeight: 600,
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.2s, background 0.2s",
                }}
                onFocus={e => {
                  e.target.style.borderColor = "rgba(255,107,0,0.7)";
                  e.target.style.background = "rgba(255,255,255,0.09)";
                }}
                onBlur={e => {
                  e.target.style.borderColor = errors.password ? "rgba(239,68,68,0.6)" : "rgba(255,255,255,0.1)";
                  e.target.style.background = "rgba(255,255,255,0.06)";
                }}
              />
              <button
                onClick={() => setShowPass(p => !p)}
                tabIndex={-1}
                style={{
                  position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: 16, padding: 4, color: "rgba(255,255,255,0.5)",
                  lineHeight: 1,
                }}
              >{showPass ? "🙈" : "👁️"}</button>
            </div>
            {errors.password && (
              <div style={{ fontSize: 11, color: "#FCA5A5", marginTop: 6, fontWeight: 700, paddingLeft: 4 }}>
                ⚠ {errors.password}
              </div>
            )}
          </div>

          {/* Submit button */}
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: "100%",
              background: loading
                ? "rgba(255,107,0,0.5)"
                : "linear-gradient(135deg, #FF6B00, #FF3D00)",
              border: "none", color: "#fff",
              fontFamily: "'Nunito', sans-serif",
              fontSize: 15, fontWeight: 900,
              padding: "16px",
              borderRadius: 14,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: loading ? "none" : "0 8px 28px rgba(255,107,0,0.45)",
              letterSpacing: 0.3,
              transition: "all 0.2s ease",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
            }}
          >
            {loading ? (
              <>
                <div style={{
                  width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)",
                  borderTopColor: "#fff", borderRadius: "50%",
                  animation: "spin 0.7s linear infinite",
                }} />
                A entrar...
              </>
            ) : (
              "Entrar na plataforma →"
            )}
          </button>
        </div>
      </div>

      {/* ── Footer note ── */}
      <p style={{
        marginTop: 28, fontSize: 12, color: "rgba(255,255,255,0.25)",
        fontWeight: 600, textAlign: "center",
        animation: "fadeSlideUp 0.6s ease 0.2s both",
      }}>
        © 2025 SATEC Imports · Acesso restrito a colaboradores
      </p>
    </div>
  );
}